import { getCurrentTimeWindowStatus } from "../utils/get-current-time-window-status.js";

//#region src/hooks/use-system-degradation-status.ts
const DEFAULT_ALERT_LEVEL = "warning";
const useSystemDegradationStatus = (flagValue) => {
	const { show, timeFrame, message, alertLevel, disableAuthFlows } = flagValue && typeof flagValue === "object" ? flagValue : { show: false };
	const isWithinWindow = getCurrentTimeWindowStatus(timeFrame?.start, timeFrame?.end) === "within";
	return {
		isActive: Boolean(show) && isWithinWindow,
		message: message ?? null,
		alertLevel: alertLevel ?? DEFAULT_ALERT_LEVEL,
		timeFrame: {
			start: timeFrame?.start ?? null,
			end: timeFrame?.end ?? null
		},
		disableAuthFlows: Boolean(disableAuthFlows)
	};
};

//#endregion
export { useSystemDegradationStatus };